'use strict';

import { reverseUrl } from 'utils/django';

import StateDiagram from 'incidents/utils/states';
import Q from 'incidents/utils/states/query';

var ArvadaStateDiagram = new StateDiagram()
	.add('acknowledged', Q('acknowledged'))
	.add('complainant contacted', Q('contacts:call_completed', 'contacts:call_skipped'))
	.add('on-scene', Q('geo:arrived'))
	.add('departed', Q('geo:departed'))
	.add('team done', Q('team:done', 'geo:location_skipped'))
	.add('awaiting approval', Q('form_skipped'));


export default function(incident) {
	ArvadaStateDiagram.updateIncident(incident);
	incident.phoneFromUrl =  reverseUrl('incidents:context:phone-number-list', {
		incident_uuid: incident.uuid,
	});
	incident.problemTypes = [
		'Billing Question',
		'Water On/Off',
		'Sewer backup',
		'Missing MH lid',
		'Street Flooding',
		'Sewer Odor',
		'Flags in my Yard',
		'Clogged storm inlets',
		'Sewer service line issues',
		'Sewer service video reviews',
		'Water in Road',
		'Parks Sprinklers',
		'Odor in Water',
		'No water',
		'Pressure Issue',
		'Dirty Water',
		'Air in Water',
		'Vibration in Pipes',
		'Broken meter pit lid',
		'Broken/missing valve box lid',
		'Water surfacing',
		'Running water',
		'Water Main Break',
		'Fire Hydrant Struck',
	]
}
